<app-custom-requisition-form
	*ngIf="vm$ | async as vm"
	[selectedRequisitionId]="data.selectedRequisitionId"
	(onSubmit)="onSubmit($event)"
	(formStatusChange)="onFormStatusChange($event)"
	[isEdit]="true"
>
	<div header-content class="flex flex-col">
		<h3>Edit Custom Requisition</h3>
		<p>Edit your firms custom requisition template.</p>
	</div>

	<ui-button
		footer-content
		preset="HIGH_EMPHASIS"
		type="submit"
		[disabled]="isDisabled"
		[loading]="vm.loading"
		label="Save"
	>
	</ui-button>
</app-custom-requisition-form>
